import PropTypes from 'prop-types';
import {createContext} from 'react';

// ==============================|| ERRORS CONTEXT & PROVIDER ||============================== //

const ErrorsContext = createContext(null);

export const ErrorsProvider = ({errorsClientRef, children}) => {

    const getErrors = (columnFiltersQuery = null, sortQuery = null, pageNumber = 0, pageSize = 99_999, ...additionalDataArguments) => {
        return errorsClientRef?.getErrors(columnFiltersQuery, sortQuery, pageNumber, pageSize, ...additionalDataArguments);
    }

    const updateError = (obj) => {
        return errorsClientRef?.updateError(obj);
    }

    return <ErrorsContext.Provider value={{getErrors, updateError}}>{children}</ErrorsContext.Provider>;
}

ErrorsProvider.propTypes = {
    errorsClientRef: PropTypes.object.isRequired,
    children: PropTypes.node
};

export default ErrorsContext;
